// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__p2b1L","middle":"styles_middle__HRt5J","title":"styles_title__0pVXY","date":"styles_date__hKjBT"};